<dx-header-curve class="curve-lg"></dx-header-curve>
<div class="page-container container-fluid"  *ngIf="isUserActive === true">
  <dx-system-notifications></dx-system-notifications>
  <div class="card-columns">
    <dx-featured-accounts *ngIf="authService.isAgent" allRoute="/account" accountRoute="/account">
    </dx-featured-accounts>
    <dx-featured-reports *ngIf="authService.isAgent && hasReports" allRoute="/resources/reports"></dx-featured-reports>
    <dx-expiring-policy-status *ngIf="authService.isAgent" allRoute="/policy/expiring">
    </dx-expiring-policy-status>
    <dx-claim-count-status *ngIf="authService.isAgent" allRoute="/claim/report"></dx-claim-count-status>
    <dx-past-due-status allRoute="/policy/past-due" policyRoute="/policy//billing"></dx-past-due-status>
    <dx-featured-links allRoute="/resources/links"></dx-featured-links>
    <dx-featured-documents allRoute="/resources/documents"></dx-featured-documents>
    <dx-featured-news maxCount="3" [highlight]="true" allRoute="/resources/news"></dx-featured-news>
  </div>
</div>
<dx-app-unauthorized-page *ngIf="isUserActive === false"></dx-app-unauthorized-page>